// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3BaZb","title":"AfterFrontImage_title__3yNgj"};